import React from "react";
import Button from "../../Button";
import Overlay from "../../Overlay";
import excalamation from "../../../assets/img/icons/table/excalamation.svg";
import Trash from "../../../assets/img/Garbage.svg";

function DeleteConfirmation({
  nameToDelete,
  isElement,
  isPlancompta = false,
  onConfirm,
  onCancel,
  open = true,
}) {
  const handleCloseDialog = () => {
    onCancel();
  };

  const handleConfirm = async () => {
    await onConfirm();
  };

  let deleteTargetLabel = " cette catégorie";
  if (isElement) {
    deleteTargetLabel = " cet élément";
  } else if (isPlancompta) {
    deleteTargetLabel = " cette ligne de plan comptable";
  }

  return (
    <Overlay show={open} closable={true} onClick={handleCloseDialog}>
      <div className="delete-confirm-wrapper" onClick={handleCloseDialog}>
        <div className="delete-confirm-container">
          <div className="are-you-sure">
            <img src={excalamation} alt={"excalamation"} />
            <p>Supprimer {nameToDelete}</p>
          </div>

          <h1>
            Êtes-vous sûr de vouloir supprimer
            {deleteTargetLabel}
            ?
          </h1>

          <div className="delete-button-containers">
            <Button
              text={"Non"}
              onClick={handleCloseDialog}
              className={"action-button"}
            />
            <Button
              text={"Oui"}
              onClick={handleConfirm}
              className={"action-button agree-action-button"}
              icon={"empty"}
              RigthIcon={Trash}
              isRigthIcon
              iconClassName={"delete-icon"}
            />
          </div>
        </div>
      </div>
    </Overlay>
  );
}

export default DeleteConfirmation;
